import { Button, Heading } from '@alefeducation/ui-elements-library-core';
import React from 'react';
import styled from 'styled-components';
import {
  StyledListContainer,
  StyledTableHeader,
} from '../CommonStyles/TableStyles';
import { CANCEL } from '../../utils/constants';
import { StyledFooter } from '../AddEditMember/Footer';

const StyledBody = styled.div``;

type Props = {
  children: React.ReactNode;
  onCancel: () => void;
  onSubmit: () => void;
  submitButtonText: string;
  headerTitle: string;
  headerDescription: string;
  isDisabled?: boolean;
};

const Form = ({
  children,
  headerTitle,
  headerDescription,
  isDisabled,
  submitButtonText,
  onSubmit,
  onCancel,
}: Props) => {
  return (
    <StyledListContainer>
      <StyledTableHeader>
        <Heading variant="heading-medium">{headerTitle}</Heading>
        <Heading variant="heading-small" weight="light" color="primary.60">
          {headerDescription}
        </Heading>
      </StyledTableHeader>

      <StyledBody>{children}</StyledBody>

      <StyledFooter>
        <Button
          data-testid="button-admin-cancel"
          variant="secondary"
          onClick={onCancel}
        >
          {CANCEL}
        </Button>
        <Button
          data-testid="button-admin-save-changes"
          onClick={onSubmit}
          disabled={isDisabled}
        >
          {submitButtonText}
        </Button>
      </StyledFooter>
    </StyledListContainer>
  );
};

export default Form;
